import React from 'react';

export function CreditCardIcon({ className }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <path
        stroke="#000"
        strokeWidth="1.5"
        d="M16.999 5h-14A1 1 0 0 0 2 6v8a1 1 0 0 0 1 1h13.999a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1ZM2 8h15.999"
      />
      <path
        fill="#000"
        d="M5 12.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M7.999 12.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M10.999 12.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
      />
    </svg>
  );
}
